module.exports = __webpack_public_path__ + "media/images/trash-danger-4a9c19f27300229d24507754bd80fde2.svg";